export default __webpack_public_path__ + "static/media/CardExample.9e447480.svg";